import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { OrderService } from '@app/core';
import { ReporteService } from '@app/core/service/reporte.service';
import { CrearVisitaComponent } from '@app/dashboard/visitas/crear-visita/crear-visita.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-reporte-visitas',
  templateUrl: './reporte-visitas.component.html',
  styleUrls: ['./reporte-visitas.component.css']
})
export class ReporteVisitasComponent implements OnInit {
  visitas: any;
  id: any;
  events: any;
  isfrmChecked: any;
  selectVisita = new FormControl('', []);
  term = new FormControl('', []);
  fecha = new FormControl('', []);

  constructor(
    public orderService: OrderService,
    private visitasService: ReporteService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.listarVisitas(0, '', '');
    this.selectVisita.valueChanges.subscribe(data => {
      this.listarVisitas(data, this.term.value, this.fecha.value);
    });
    this.term.valueChanges.subscribe(data => {
      this.listarVisitas(this.selectVisita.value, data, this.fecha.value);
    });
    this.fecha.valueChanges.subscribe(data => {
      this.listarVisitas(this.selectVisita.value, this.term.value, data);
    });
  }

  listarVisitas(data: any, term: any, fecha: any) {
    this.visitasService.visitasCliente(data, term, fecha).subscribe(data => {
      this.visitas = data;
      console.log('visitas', this.visitas);
    });
  }

  crearPDF() {
    // console.log(this.Array);

    this.visitasService
      .visitasCliente(
        this.selectVisita.value,
        this.term.value,
        this.fecha.value
      )
      .subscribe(x => {
        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should
        const newBlob = new Blob([x], { type: 'application/pdf' });

        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob

        // For other browsers:
        // Create a link pointing to the ObjectURL containing the blob.
        const data = window.URL.createObjectURL(newBlob);
        const date = new Date();
        const link = document.createElement('a');
        link.href = data;
        link.download = 'visita_' + date + '.pdf';
        // this is necessary as link.click() does not work on the latest firefox
        link.dispatchEvent(
          new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
          })
        );

        setTimeout(function() {
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(data);
          link.remove();
        }, 100);
      });
  }
}
